export const NUM_OF_CARS = "# of Cars";
export const NUM_OF_CARS_1 = "# of Cars 1";
export const NUM_OF_CARS_2 = "# of Cars 2";
export const ABOVE_GRADE = "Above Grade";
export const ACRES = "Acres";
export const ACTUAL_AGE = "Actual Age";
export const ADDRESS = "Address";
export const ADDRESS_2 = "Address 2";
export const ADJ_GROSS_PRICE = "Adj. Gross Price";
export const ADJ_NET_PRICE = "Adj. Net Price";
export const ADJUSTMENTS_ROOM_COUNT = "Adjustments Room Count";
export const ADJUSTMENTS_UNIT_1 = "Adjustments Unit 1";
export const ADJUSTMENTS_UNIT_2 = "Adjustments Unit 2";
export const ADJUSTMENTS_UNIT_3 = "Adjustments Unit 3";
export const ADJUSTMENTS_UNIT_4 = "Adjustments Unit 4";
export const ADJUSTMENTS_SITE = "Adjustments Site";
export const ADJUSTMENTS_AGE = "Adjustments Age";
export const ADJUSTMENTS_GLA = "Adjustments GLA";
export const ATT_DET = "Att/Det";
export const ATTACHMENT_TYPE_1 = "Attachment Type 1";
export const ATTACHMENT_TYPE_2 = "Attachment Type 2";
export const BASEMENT_FINISHED = "Basement & Finished";
export const BASEMENT_EXIT_TYPE = "Basement Exit Type";
export const BATHROOMS = "Bathrooms";
export const BED = "Bed";
export const BEDROOMS = "Bedrooms";
export const BELOW_GRADE = "Below Grade";
export const BELOW_GRADE_FIN_SF = "Below Grade Fin SF";
export const BELOW_GRADE_TOT_SF = "Below Grade Tot SF";
export const CAR_STORAGE_1 = "Car Storage 1";
export const CAR_STORAGE_2 = "Car Storage 2";
export const CITY = "City";
export const COMPARABLE_TYPE = "Comparable Type";
export const CONCESSION_IF_OTHER = "Concession (if other)";
export const CONCESSION_AMOUNT = "Concession Amount";
export const CONDITION = "Condition";
export const CONTRACT_DATE = "Contract Date";
export const COOLING_1004P = "Cooling 1004P";
export const DATA_SOURCES_1004P = "Data Sources 1004P";
export const DATE_OF_SALE_TIME = "Date of Sale/Time";
export const DAYS_ON_MARKET = "Days On Market";
export const DESIGN = "Design";
export const DESIGN_STYLE = "Design (Style)";
export const DRIVEWAY = "Driveway";
export const ENERGY_EFFICIENT_ITEMS = "Energy Efficient Items";
export const ESTIMATED = "Estimated";
export const FEATURE = "Feature";
export const FINANCING_CONCESSIONS = "Financing Concessions";
export const FINANCING_TYPE = "Financing Type";
export const FULL_BATH = "Full Bath";
export const FUNCTIONAL_UTILITY = "Functional Utility";
export const GARAGE_CARPORT = "Garage/Carport";
export const GLA = "GLA";
export const HALF_BATH = "Half Bath";
export const HALF_BATHROOMS = "Half bathrooms";
export const HEATING_1004P = "Heating 1004P";
export const HEATING_COOLING = "Heating/Cooling";
export const LATITUDE = "Latitude";
export const LEASEHOLD_FEE_SIMPLE = "Leasehold/Fee Simple";
export const LOCATION = "Location";
export const LOCATION_RATING = "Location Rating";
export const LOCATION_TYPE = "Location Type";
export const LOCATION_TYPE_1_OTHER = "LOCATION_TYPE_1_OTHER";
export const LOCATION_TYPE_2 = "Location Type 2";
export const LOCATION_TYPE_2_OTHER = "LOCATION_TYPE_2_OTHER";
export const LONGITUDE = "Longitude";
export const NET_ADJ = "Net Adj.";
export const OTHER = "Other";
export const OTHER_1_DESC = "Other 1 desc.";
export const OTHER_2_DESC = "Other 2 desc.";
export const OTHER_3_DESC = "Other 3 desc.";
export const OTHER_NAME_1 = "Other Name 1";
export const OTHER_NAME_2 = "Other Name 2";
export const OTHER_NAME_3 = "Other Name 3";
export const PORCH_PATIO_DECK = "Porch/Patio/Deck";
export const PRIMARY_PHOTO = "Primary photo";
export const PROXIMITY_TO_SUBJECT = "Proximity to subject";
export const QUALITY = "Quality";
export const REC = "Rec";
export const ABOVE_GRADE_ROOM_COUNT = "Above Grade Room Count";
export const BELOW_GRADE_ROOM_COUNT = "Below Grade Room Count";
export const SALE_1004P = "Sale 1004P";
export const SALE_DATE_1004P = "Sale Date 1004P";
export const SALE_OR = "Sale or";
export const SALE_PRICE = "Sale Price";
export const SALE_PRICE_GLA = "Sale Price / GLA";
export const SITE = "Site";
export const SQUARE_FEET = "Square Feet";
export const STATE = "State";
export const STATUS_TYPE = "Status Type";
export const STORIES = "Stories";
export const TOTAL = "Total";
export const VALUE_ADJUSTMENTS = "Value Adjustments";
export const VERIFICATION_SOURCES = "Verification source(s)";
export const VIEW = "View";
export const VIEW_RATING = "View Rating";
export const VIEW_TYPE = "View Type";
export const VIEW_TYPE_2 = "View Type 2";
export const ZIP = "Zip";
export const CDOM = "CDOM";
export const CDOM_WITH_SUBJECT = "CDOM";
export const PROPERTY_TYPE = "Property Type";
export const NUM_OF_UNITS = "Number of Units";
export const YEAR_BUILT = "Year Built";
export const NUM_OF_FLOORS = "# of Floors";
export const FLOOR_LOCATION = "Floor Location";
export const MONTHLY_RENTAL_RATE = "Monthly Rental Rate";
export const BELOW_GRADE_ROOM_COUNT_FNMA = "Below Grade Room Count FNMA";
export const SALE_FNMA = "Sale FNMA";
export const SALE_DATE_FNMA = "Sale Date FNMA";
export const HEATING_FNMA = "Heating FNMA";
export const COOLING_FNMA = "Cooling FNMA";
export const POOL = "Pool";
export const PORCH = "Porch";
export const PATIO_DECK = "Patio/Deck";
export const DATA_SOURCES_FNMA = "Data Sources FNMA";
export const UNIT_1 = "Unit 1";
export const TOTAL_UNIT_1 = "Total Unit 1";
export const BEDROOMS_UNIT_1 = "Bedrooms Unit 1";
export const BATHROOMS_UNIT_1 = "Bathrooms Unit 1";
export const HALF_BATHROOMS_UNIT_1 = "Half Bathrooms Unit 1";
export const UNIT_2 = "Unit 2";
export const TOTAL_UNIT_2 = "Total Unit 2";
export const BEDROOMS_UNIT_2 = "Bedrooms Unit 2";
export const BATHROOMS_UNIT_2 = "Bathrooms Unit 2";
export const HALF_BATHROOMS_UNIT_2 = "Half Bathrooms Unit 2";
export const UNIT_3 = "Unit 3";
export const TOTAL_UNIT_3 = "Total Unit 3";
export const BEDROOMS_UNIT_3 = "Bedrooms Unit 3";
export const BATHROOMS_UNIT_3 = "Bathrooms Unit 3";
export const HALF_BATHROOMS_UNIT_3 = "Half Bathrooms Unit 3";
export const UNIT_4 = "Unit 4";
export const TOTAL_UNIT_4 = "Total Unit 4";
export const BEDROOMS_UNIT_4 = "Bedrooms Unit 4";
export const BATHROOMS_UNIT_4 = "Bathrooms Unit 4";
export const HALF_BATHROOMS_UNIT_4 = "Half Bathrooms Unit 4";
export const ACTUAL_AGE_MVALUE = "Actual Age MValue";
export const OTHER_MVALUE = "Other MValue";
export const SALE_DATE_BBT = "SALE_DATE_BBT";
export const SITE_BBT = "SITE_BBT";
export const QUALITY_BBT = "QUALITY_BBT";
export const ACTUAL_AGE_BBT = "ACTUAL_AGE_BBT";
export const CONDITION_BBT = "CONDITION_BBT";
export const ABOVE_GRADE_BBT = "ABOVE_GRADE_BBT";
export const ABOVE_GRADE_ROOM_COUNT_BBT = "ABOVE_GRADE_ROOM_COUNT_BBT";
export const TOTAL_BBT = "TOTAL_BBT";
export const BEDROOMS_BBT = "BEDROOMS_BBT";
export const BATHROOMS_BBT = "BATHROOMS_BBT";
export const HALF_BATHROOMS_BBT = "HALF_BATHROOMS_BBT";
export const GLA_BBT = "GLA_BBT";
export const BASEMENT_FINISHED_BBT = "BASEMENT_FINISHED_BBT";
export const BELOW_GRADE_TOT_SF_BBT = "BELOW_GRADE_TOT_SF_BBT";
export const BELOW_GRADE_FIN_SF_BBT = "BELOW_GRADE_FIN_SF_BBT";
export const BASEMENT_EXIT_TYPE_BBT = "BASEMENT_EXIT_TYPE_BBT";
export const GARAGE_CARPORT_BBT = "GARAGE_CARPORT_BBT";
export const DRIVEWAY_BBT = "DRIVEWAY_BBT";
export const NUM_OF_CARS_BBT = "NUM_OF_CARS_BBT";
export const CAR_STORAGE_1_BBT = "CAR_STORAGE_1_BBT";
export const ATTACHMENT_TYPE_1_BBT = "ATTACHMENT_TYPE_1_BBT";
export const NUM_OF_CARS_1_BBT = "NUM_OF_CARS_1_BBT";
export const CAR_STORAGE_2_BBT = "CAR_STORAGE_2_BBT";
export const ATTACHMENT_TYPE_2_BBT = "ATTACHMENT_TYPE_2_BBT";
export const NUM_OF_CARS_2_BBT = "NUM_OF_CARS_2_BBT";
export const OTHER_BBT = "OTHER_BBT";
export const COMPARISON_TO_SUBJECT = "COMPARISON_TO_SUBJECT";
export const COMMENTS = "COMMENTS";
export const FINAL_LIST_PRICE = "FINAL_LIST_PRICE";
export const GARAGE_CARPORT_MVALUE = "GARAGE_CARPORT_MVALUE";
export const DRIVEWAY_ENABLED = "DRIVEWAY_ENABLED";
export const NUM_OF_CARS_MVALUE = "NUM_OF_CARS_MVALUE";
export const CAR_STORAGE_1_MVALUE = "CAR_STORAGE_1_MVALUE";
export const ATTACHMENT_TYPE_1_MVALUE = "ATTACHMENT_TYPE_1_MVALUE";
export const NUM_OF_CARS_1_MVALUE = "NUM_OF_CARS_1_MVALUE";
export const CAR_STORAGE_2_MVALUE = "CAR_STORAGE_2_MVALUE";
export const ATTACHMENT_TYPE_2_MVALUE = "ATTACHMENT_TYPE_2_MVALUE";
export const NUM_OF_CARS_2_MVALUE = "NUM_OF_CARS_2_MVALUE";
